import { render } from "./Chatbot.vue?vue&type=template&id=25364231&scoped=true&ts=true"
import script from "./Chatbot.vue?vue&type=script&lang=ts"
export * from "./Chatbot.vue?vue&type=script&lang=ts"

import "./Chatbot.vue?vue&type=style&index=0&id=25364231&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25364231"]])

export default __exports__